/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { useSelector } from "react-redux";
import { Store } from "store";

type ErrorModalProps = {
  caption?: string;
  msg: string;
  closeModal: () => void;
};
export const ErrorModal: React.FC<ErrorModalProps> = (props) => {
  const { t } = useI18n();
  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );
  const classes = errorModalStyles({ isDarkModeEnabled });
  return (
    <div css={classes.root}>
      <p css={classes.headline}>
        {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
        {props.caption || t("streaming.commerceModal.errorHeading")}
      </p>
      <p css={classes.text}>{props.msg}</p>
      <div css={classes.buttonList}>
        <p css={classes.close} onClick={props.closeModal}>
          {t("streaming.commerceModal.closeButton")}
        </p>
      </div>
    </div>
  );
};
const errorModalStyles = (props: { isDarkModeEnabled: boolean }) => {
  const fontColor = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;
  return {
    root: css`
      height: 400px;
      padding: 32px 16px;
      border: 1px solid #e0e0e0;
    `,
    headline: css`
      margin-bottom: 24px;
      font-weight: bold;
      text-align: center;
      ${fontColor}
    `,
    text: css`
      margin-bottom: 16px;
      font-size: 14px;
      line-height: 1.5em;
      ${fontColor}
    `,
    buttonList: css`
      margin: 24px 0 0;
      p {
        padding: 10px 0px;
        text-align: center;
        cursor: pointer;
      }
    `,
    close: css`
      color: #fff;
      font-size: 14px;
      background-color: #00c2ae;
      border: 2px solid #fff;
    `,
  };
};
